import React from 'react'
interface Props {
    isLoading: boolean
    message?: string
    children: React.ReactNode
}

export default function RelativeLoadingOverlayFrame({
    isLoading,
    message,
    children
}: Props) {
    return (
        <div className={`relative w-full ${isLoading ? 'min-h-[40vh]' : 'h-full'}`}>
            {children}
            {isLoading && (
                <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-white/70 backdrop-blur-sm">
                    <img src="/loader-slow.gif" className="h-16 w-16" alt="Loading" />
                    {message && (
                        <p className="text-lg text-gray-400 mt-2">
                            {message}
                        </p>
                    )}
                </div>
            )}
        </div>
    )
}
